const { Type } = require('@sinclair/typebox');
const { actionUtils, config } = require('@sstdev/lib_metadata-config');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const Blockly = require('blockly');

const TOOLTIP = 'A button to put on a form that expands to show a menu of options.';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    blocklyBlock.setInputsInline(false);

    line1OfInputs
        .appendField('  Icon Name:')
        .appendField(new Blockly.FieldTextInput(''), 'iconName')
        .appendField('  Button Style (old):')
        .appendField(new Blockly.FieldDropdown(config.buttonStyles), 'buttonStyle')
        .appendField('  Button Size (new):')
        .appendField(new Blockly.FieldDropdown(config.componentSize), 'size')
        .appendField('  Button Variant (new):')
        .appendField(new Blockly.FieldDropdown(config.buttonVariants), 'variant');

    blocklyBlock.appendStatementInput('children').setCheck('menuSelection').appendField('Menu', 'childrenField');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['title', 'iconName', 'buttonStyle', 'size', 'variant']);
    return code;
}

/** Builds schema for the form MenuButton and returns [subDataDictionary, partialTypeDefinition]. */
function asDataDictionary(hNode, context = {}, parentAccessRestrictions) {
    const accessRestrictions = actionUtils.getNodeAccessRestrictions(hNode, context, parentAccessRestrictions);
    if (accessRestrictions.hidden) return [{}, {}];

    // Form MenuButton is a container for menu items within a form context
    // It doesn't define namespace/relation itself - it uses the parent form's context
    // The menu children may contain actions, but the button itself doesn't contribute schema properties
    return [{}, {}];
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
